<template>
  <div>
    <table-list
      title="管理员列表"
      :loading="loading"
      :data="adminList"
      :columns="columns(this)"
      :operates="operates(this)"
      :btns="btns(this)"
      :pager="pager"
      :options="{ selection: true }"
      @size-change="handleSizeChange"
      @selectionChange="handleSelectionChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <Distribution ref="distribution" @success="getAdminListData"></Distribution>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '添加管理员',
    method: _this.handleAdd,
    type: 'primary',
  },
  {
    label: '删除',
    method: _this.handleDelete,
    type: 'primary',
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'userName',
    label: '姓名',
    minWidth: 120,
  },
  {
    prop: 'phone',
    label: '手机号码',
    minWidth: 120,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 120,
  },
  {
    prop: 'roleNames',
    label: '管理员角色',
    minWidth: 100,
  },
  {
    prop: 'createTime',
    label: '添加时间',
    minWidth: 150,
    sortdata: 1,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    label: '分配角色',
    method: _this.handleRole,
  },
]
import TableList from '@/components/TableList'
import Distribution from './Distribution'
import { getAdminList, adminDelete } from '@/api/system'
import to from 'await-to'
export default {
  name: 'UserManage',
  components: {
    TableList,
    Distribution,
  },
  data() {
    return {
      columns,
      loading: false,
      btns,
      operates,
      adminList: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      select: [],
      queryParams: {},
      clientCode: '52817232-63e9-11ed-a8c9-506b4b42',
    }
  },
  mounted() {
    this.getAdminListData()
  },
  methods: {
    async getAdminListData() {
      if (this.loading) return
      this.loading = true
      const { size, current } = this.pager
      const [res, err] = await to(getAdminList({ size, current, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.adminList = res.data.list
      this.pager.total = res.data.total
    },
    // 删除
    async handleDelete() {
      if (!this.select.length) return this.$message.warning('选择某个管理员进行删除')
      let arr = []
      this.select.map(v => arr.push(v.id))
      this.$confirm('您确定要删除吗？删除后将不可恢复', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(adminDelete({ ids: arr }))
          if (err) return this.$message({ type: 'error', message: err.msg })
          this.$message({ type: 'success', message: '删除成功' })
          this.getAdminListData()
        })
        .catch(() => {})
    },
    handleAdd() {
      this.$router.push({
        path: '/system/adminAdd',
      })
    },
    handleRole(row) {
      this.$refs.distribution.show(row.id, row.roleIds)
    },
    handleSelectionChange(val) {
      this.select = val
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getAdminListData()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getAdminListData()
    },
  },
}
</script>
